import { render, staticRenderFns } from "./FeedbackYesNoWidget.vue?vue&type=template&id=6575ff2b&scoped=true"
import script from "./FeedbackYesNoWidget.vue?vue&type=script&lang=js"
export * from "./FeedbackYesNoWidget.vue?vue&type=script&lang=js"
import style0 from "./FeedbackYesNoWidget.vue?vue&type=style&index=0&id=6575ff2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6575ff2b",
  null
  
)

export default component.exports